import { useState, useCallback } from "react";
import { Button } from "../../components/Button";

import image from "./../../assets/image-modalConfirm.svg";
import image2 from "./../../assets/image-modalPrompt.svg";

import styles from "./styles.module.scss";
import { Modal } from "@mui/material";

export const useConfirm = (
  message: string,
  _openModal?: boolean,
  _handleCloseModal?: any,
  description?: string,
  noDelete?: boolean
) => {
  const [isConfirmVisible, setConfirmVisible] = useState(false);
  const [result, setResult] = useState<boolean | null>(null);

  const showConfirm = useCallback((): Promise<boolean> => {
    setConfirmVisible(true);
    return new Promise<boolean>((resolve) => {
      const handleConfirm = () => {
        setConfirmVisible(false);
        setResult(true);
        resolve(true);
      };

      const handleCancel = () => {
        setConfirmVisible(false);
        setResult(false);
        resolve(false);
      };

      setHandlers({ handleConfirm, handleCancel });
    });
  }, []);

  const [handlers, setHandlers] = useState({
    handleConfirm: () => { },
    handleCancel: () => { },
  });

  const Confirm = isConfirmVisible ? (
    <>
      <Modal
        open={isConfirmVisible}
        onClose={() => handlers.handleCancel()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className={styles.overlay}>
          <div className={styles.confirmBox}>
            <div className={styles.textAndImage}>
              <div className={styles.text}>
                <h3>{message}</h3>
                <p>
                  {description ??
                    "Após a exclusão não terá como recuperar ela novamente."}
                </p>
              </div>
              <div className={styles.image}>
                <img src={noDelete ? image2 : image} alt="" />
              </div>
            </div>
            <div className={styles.btns}>
              <Button
                onClick={handlers.handleCancel}
                content="Não"
                variant="solidPurple"
              />
              <Button
                onClick={handlers.handleConfirm}
                content="Sim"
                variant="cancelPurple"
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  ) : null;

  return { showConfirm, result, Confirm };
};
